"use client";

import { useParams } from "next/navigation";
import { use } from "react";

import { NotificationCategory } from "@/backend/focus";
import { EarningsFilterHeader } from "@/components/app/earnings/earnings-filter-header";
import { EarningsNotificationsTable } from "@/components/app/earnings/earnings-notifications-table";
import {
  NOTIFICATION_FIELDS,
  NotificationsProvider,
} from "@/components/app/notifications/notifications-context";
import { useIsLoggedIn } from "@/components/shared/is-logged-in";
import type { FilterRecord } from "@/contexts/filters-sort-context";
import { FilterType } from "@/contexts/filters-sort-context";
import { UserContext } from "@/contexts/user-context";
import { LocalStorageKeys } from "@/utils/local-storage-keys";

import { SearchEarnings } from "./search-earnings";

const revenueFilter: FilterRecord = {
  type: FilterType.string,
  name: NOTIFICATION_FIELDS.category,
  value: NotificationCategory.EARNINGS,
};

export default function EarningsLayout({ publicKey }: { publicKey?: string }) {
  const { currentUserPublicKey } = use(UserContext);
  const { id: username } = useParams();
  const isLoggedIn = useIsLoggedIn();

  if (!isLoggedIn && !username) {
    return <SearchEarnings />;
  }

  return (
    <NotificationsProvider
      storageKey={LocalStorageKeys.earningsFiltersAndSort}
      initialFilters={[revenueFilter]}
      publicKey={publicKey}
      markUnreadNotificationsAsRead={false}
      showUnreadIndicator={false}
      relativeUsername={
        publicKey !== currentUserPublicKey ? username?.toString() : null
      }
    >
      <EarningsFilterHeader />
      <EarningsNotificationsTable />
    </NotificationsProvider>
  );
}
